import { LANGUAGES, SUPPORTED_LANGUAGES } from "./types";

export const i18nConfig = {
  backend: {
    loadPath: `${process.env.REACT_APP_API_URL}/translations/{{lng}}`,
  },
  detection: {
    order: ["querystring", "localStorage", "navigator"],
    lookupQuerystring: "lng",
    lookupLocalStorage: "i18nextLng",
    caches: ["localStorage"],
  },
  supportedLngs: SUPPORTED_LANGUAGES,
  load: "languageOnly",
  fallbackLng: LANGUAGES.EN,
  interpolation: {
    escapeValue: false,
  },
};
